<template>
  <div class="col-md-12">
    <div class="text-center loading-overlay" v-if="loading">
      <b-spinner></b-spinner>
    </div>
    <b-row>
      <b-col md="6" class="my-2">
        <p class="m-0 p-0">Name</p>
        <b-form-input v-model="lname" placeholder="Name" />
      </b-col>
      <b-col md="6" class="my-2">
        <p class="m-0 p-0">Email</p>
        <b-form-input v-model="lemail" placeholder="Mobile" />
      </b-col>
      <b-col md="6" class="my-2">
        <p class="m-0 p-0">Mobile</p>
        <b-form-input v-model="lphone" placeholder="Email Id" />
      </b-col>
      <b-col md="6" class="my-2">
        <p class="m-0 p-0">Amount</p>
        <b-form-input type="number" v-model="amount" placeholder="Amount" />
      </b-col>
    </b-row>
    <div class="py-4">
      <b-alert show variant="warning">
        <i class="fal fa-exclamation-triangle"></i>
        The below button sends a payment link directly from Razorpay, no records/logs are recorded internally but are recorded in the Razorpay dashboard. Please use this panel wisely.
      </b-alert>
    </div>
    <div class="my-4 text-right">
      <b-button @click="sendPaymentLink" variant="primary">Send Payment Link</b-button>
    </div>
  </div>
</template>

<script>
import { HTTP2 } from "../../axios/http-common";
export default {
  data() {
    return {
      lname: "",
      lemail: "",
      lphone: "",
      amount: 0,
      loading: false,
    };
  },
  props: {
    name: String,
    email: String,
    phone: String,
  },
  created() {
    this.lname = this.name;
    this.lemail = this.email;
    this.lphone = this.phone;
  },
  methods: {
    async sendPaymentLink() {
      const payload = {
        name: this.lname,
        email: this.lemail,
        phone: this.lphone,
        agentID: localStorage.getItem(""),
        agentName: localStorage.getItem(""),
        amount: this.amount * 100,
      }
      this.loading = true
      try {
        await HTTP2.post("/rzp/sendPaymentLink", payload);
      } catch {
        this.$toasted.global.my_app_error();
      } finally {
        this.loading = false
        this.$toasted.show("Link Sent Sucessfully", { type: "success" }).goAway(2000);
      }
    },
  },
};
</script>

<style>
.loading-overlay {
  position: absolute;
  width: 100%;
  margin: 10% 0;
  color: #7b72ff;
  z-index: 999;
}
</style>
